/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Spin } from 'antd';
import { useEffect, useState } from 'react';
import StepWizard from 'react-step-wizard';
import Step1 from './Step1';
import Step2 from './Step2';
import Step4 from './Step4';

import Preview from './Preview';

import TemplateDesignService from '../../../../../services/TemplateDesign.service';
import useNotify from '../../../../../context/Notification/useNotify';
import { useTranslation } from 'react-i18next';
import ModalConfirm from '../../../../../components/Shared/modal/confirm';
import { useNavigate, useParams } from 'react-router-dom';
import { useBlocker } from '../../../../../util/usePrompt';
import ModalDiscardChanges from '../../../../../components/Shared/modal/discardChanges';
import { ROUTER } from '../../../../../constants/router';
import { getNextVersion } from '../../TemplateTerm/components/Steps';
import { initialConsent } from './init';
import moment from 'moment';
import Step5 from './Step5';
import Step3 from './Step3';

const Steps = ({ edit }) => {
    const { t } = useTranslation(['consent', 'transaction']);

    const [state, updateState] = useState();
    const [values, setValues] = useState(initialConsent);
    const [image, setImage] = useState('');
    const [consents, setConsents] = useState();
    const [notes, setNotes] = useState([]);
    const [published, setPublished] = useState(false);
    const [editObject, setEditObject] = useState();
    const [currentSelectList, setCurrentSelectList] = useState(1);
    const [loading, setLoading] = useState(false);
    const [spinning, setSpinning] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [loadingSaveDraft, setLoadingSaveDraft] = useState(false);
    const [addNote, setAddNote] = useState();
    const [combinedDragData, setCombinedDragData] = useState([]);
    const [removeNote, setRemoveNote] = useState();
    const [triggerNote, setTriggerNote] = useState();
    const [fakeNote, setFakeNote] = useState();

    const [form] = Form.useForm();

    const notify = useNotify();
    const { key } = useParams();

    // Discard changes
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    let navigate = useNavigate();
    useBlocker((nextLocation) => onChangePage(nextLocation), change);
    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(nextLocation.location.pathname);
    };
    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    // Wizard
    const setInstance = (SW) =>
        updateState({
            ...state,
            SW,
        });

    const consentFormsGenerator = (value) => {
        let sortedArray = [];
        if (edit || value?.length > 0) {
            let consentForms = [...combinedDragData];
            let consentObj = consentForms.filter(
                (obj) => obj?.type === 'Consent'
            );
            let noteObj = consentForms.filter((obj) => obj?.type !== 'Consent');
            if (value?.length > 0) {
                let newConsentObj = [];
                for (let consent of value) {
                    const exists = consentObj.find(
                        (item) => item.consentTxnGroupId === consent
                    );
                    if (exists) {
                        newConsentObj.push(exists);
                    } else {
                        const consentData = consents.find(
                            (c) => c.consentTxnGroupId === consent
                        );
                        if (consentData) {
                            const new_obj = {
                                consentTxnGroupId:
                                    consentData.consentTxnGroupId,
                                sequence: combinedDragData.length + 1,
                                consentNameTh: consentData.consentNameTh,
                                consentNameEn: consentData.consentNameEn,
                                isConsented: consentData.isConsented,
                                purposeTh: consentData.purposeTh,
                                purposeEn: consentData.purposeEn,
                                type: 'Consent',
                                noteId: null,
                                titleTh: null,
                                titleEn: null,
                            };
                            newConsentObj.push(new_obj);
                        }
                    }
                }
                const newCombinedDragData = [...newConsentObj, ...noteObj];
                const sort = newCombinedDragData
                    .slice()
                    .sort((a, b) => a.sequence - b.sequence);
                sortedArray = sort.map((obj, index) => ({
                    ...obj,
                    sequence: index + 1,
                }));
            } else {
                const newCombinedDragData = [...noteObj];
                sortedArray = newCombinedDragData.map((obj, index) => ({
                    ...obj,
                    sequence: index + 1,
                }));
            }
        }

        return sortedArray;
    };

    const onValuesChange = (change, values) => {
        if (change) {
            setChange(true);
        }
        setValues(values);
        if (values?.consents) {
            let consentForms = consentFormsGenerator(values?.consents).filter(
                Boolean
            );
            if (consentForms.length > 0)
                form.setFieldValue('consentForms', consentForms);
            setCombinedDragData(consentForms);
        }
    };

    const onFinish = async (values) => {
        const consentForms = combinedDragData.map((consent, index) => {
            if (consent?.type === 'Consent') {
                return {
                    consentTxnGroupId: consent?.consentTxnGroupId,
                    type: 'consent',
                    sequence: consent?.sequence,
                };
            } else {
                return {
                    noteId: null,
                    type: 'note',
                    sequence: consent?.sequence,
                    titleEn: consent?.titleEn,
                    titleTh: consent?.titleTh,
                };
            }
        });

        let isRequireOtp = false
        if (values.isRequireOtp) {
            isRequireOtp = true
        } 
        
        const templateDesignIdentity = values?.templateDesignIdentity?.map(
            (item, index) => {
                return {
                    ...item,
                    sequence: index + 1,
                };
            }
        );

        let template = {
            ...values,
            consentForms,
            templateDesignIdentity,
            isPublish: published,
            isRequireOtp: isRequireOtp
        };
        let service = TemplateDesignService.saveTemplateConsent;
        if (edit) {
            const consentForms = combinedDragData.map((item) => {
                if (item?.type === 'Consent') {
                    return {
                        consentTxnGroupId: item?.consentTxnGroupId,
                        sequence: item?.sequence,
                    };
                } else {
                    return {
                        noteId: item?.noteId,
                        sequence: item?.sequence,
                    };
                }
            });

            template = {
                ...values,
                consentForms,
                templateDesignIdentity,
                isPublish: published,
                templateId: editObject.templateId,
                templateKey: editObject.templateKey,
                isRequireOtp: isRequireOtp
            };
            service = TemplateDesignService.updateTemplateConsent;
        }
        try {
            const { data } = await service(template);
            if (data.resultCode === 1) {
                notify({
                    title: t('Success'),
                    description: t('Successfully save data'),
                });
                setLoading(false);
                setOpenConfirm(false);
                setLoadingSaveDraft(false);
                // if (edit) getTemplateWishKey();
                setTimeout(() => {
                    navigate(`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}`);
                }, 1000);
            } else {
                notify({
                    type: 'error',
                    title: t('Fail'),
                    description: t('Failed to confirmed data'),
                });
                setLoading(false);
                setLoadingSaveDraft(false);
                setOpenConfirm(false);
            }
            handelOk();
        } catch (error) {
            notify({
                type: 'error',
                title: t('Fail'),
                description: t('Failed to confirmed data'),
            });
            setLoading(false);
            setOpenConfirm(false);
            console.log(error);
        }
    };

    const getConsentPublished = async () => {
        try {
            const payload = {
                consentType: 'Consent',
            };
            const { data } = await TemplateDesignService.getConsentPublished(
                payload
            );
            if (data.resultData) {
                setConsents(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getNote = async () => {
        if (key) {
            try {
                const { data } = await TemplateDesignService.getNotes(key);
                if (data?.resultData) {
                    setNotes(
                        data.resultData?.templateDesignNoteListResponse || []
                    );
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            const updatedArray = notes.filter((item) => {
                return item.noteId !== removeNote;
            });
            const sortedArray = updatedArray.map((obj, index) => ({
                ...obj,
                sequence: index + 1,
            }));

            setNotes(sortedArray);

            const updatedCombined = combinedDragData.filter((item) => {
                return item.noteId !== removeNote || item === true;
            });
            const newCombinedDragData = [...updatedCombined];
            const sortedCombined = newCombinedDragData.map((obj, index) => ({
                ...obj,
                sequence: index + 1,
            }));
            setCombinedDragData(sortedCombined);
        }
    };

    const generateNote = async () => {
        setCombinedDragData(editObject?.consentForms);
    };

    const addNoteFromCombinedDragData = async () => {
        const newCombinedDragData = [...combinedDragData];
        newCombinedDragData.push(addNote);
        setCombinedDragData(newCombinedDragData);
    };

    const findSequenceById = (id) => {
        const foundItem = combinedDragData.find((item) => item.noteId === id);
        return foundItem ? foundItem.sequence : combinedDragData.length + 1;
    };
    const addFakeNote = async () => {
        if (fakeNote?.length > 0) {
            const addNewNote = fakeNote.map((obj, index) => ({
                consentTxnGroupId: null,
                consentId: null,
                sequence: findSequenceById(obj.noteId),
                consentNameTh: null,
                consentNameEn: null,
                isConsented: null,
                purposeTh: null,
                purposeEn: null,
                type: null,
                noteId: obj.noteId,
                titleTh: obj.titleTh,
                titleEn: obj.titleEn,
            }));

            const newCombined = combinedDragData.filter((item) => {
                return item.type === 'Consent';
            });
            const mergeArr = [...newCombined, ...addNewNote];

            const sort = mergeArr
                .slice()
                .sort((a, b) => a.sequence - b.sequence);
            setCombinedDragData(sort);
        }
    };
    const getMasterTemplateDesign = async () => {
        try {
            const payload = {
                consentType: 'Consent',
            };
            const { data } =
                await TemplateDesignService.getMasterTemplateDesign(payload);
            if (data.resultData) {
                const resultData = {
                    ...data.resultData,
                    contactChannelTh: data.resultData?.nameDPOTh,
                    contactChannelEn: data.resultData?.nameDPOEn,
                };
                form.setFieldsValue(resultData);
                onValuesChange(false, resultData);
                setSpinning(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Edit
    const getTemplateWishKey = async () => {
        try {
            const { data } = await TemplateDesignService.getTemplateWishKey(
                key
            );
            if (data.resultData) {
                const data_ = data.resultData;
                setEditObject(data_);
                getNote();

                const consentFilter = data_?.consentForms.filter(
                    (obj) => obj?.consentTxnGroupId !== null
                );
                const consents = consentFilter.map(
                    (consent) => consent?.consentTxnGroupId
                );
                const resultData = {
                    ...data_,
                    effectiveDate: data_?.effectiveDate
                        ? moment(data_?.effectiveDate)
                        : moment(),
                    consents,
                };
                form.setFieldsValue(resultData);
                onValuesChange(false, resultData);
                setCombinedDragData(resultData.consentForms);
                setSpinning(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        setSpinning(true);
        if (consents) {
            if (edit) getTemplateWishKey();
            else getMasterTemplateDesign();
        }
        setSpinning(false);
    }, [edit, key, consents]);

    useEffect(() => {
        getConsentPublished();
    }, []);

    useEffect(() => {
        generateNote();
    }, [editObject]);

    useEffect(() => {
        getNote();
    }, [triggerNote, removeNote]);

    useEffect(() => {
        addNoteFromCombinedDragData();
    }, [addNote]);
    useEffect(() => {
        addFakeNote();
    }, [fakeNote]);
    const version = editObject?.latestPublishedVersion
        ? getNextVersion(editObject?.latestPublishedVersion)
        : '0001.0';

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                initialValues={initialConsent}
                form={form}
                name="consentForm"
                layout="vertical"
                onFinish={onFinish}
                onValuesChange={onValuesChange}
            >
                <div className="grid grid-cols-10 gap-4 py-6 overflow-hidden">
                    <div className="col-span-4 rounded-lg">
                        <StepWizard
                            isHashEnabled
                            instance={setInstance}
                            initialStep={currentSelectList}
                            currentStep={currentSelectList}
                            onStepChange={(stats) =>
                                setCurrentSelectList(stats.activeStep)
                            }
                        >
                            <Step1 setImage={setImage} form={form} />
                            <Step2 consents={consents} form={form} />
                            <Step3 form={form} />
                            <Step4 form={form} />
                            <Step5
                                form={form}
                                setAddNote={setAddNote}
                                notes={notes}
                                editObject={editObject}
                                edit={edit}
                                setNotes={setNotes}
                                addNote={addNote}
                                setRemoveNote={setRemoveNote}
                                setTriggerNote={setTriggerNote}
                                triggerNote={triggerNote}
                                combinedDragData={combinedDragData?.filter(
                                    (c) => c !== undefined
                                )}
                                setCombinedDragData={setCombinedDragData}
                                setFakeNote={setFakeNote}
                            />
                        </StepWizard>
                    </div>
                    <div className="col-span-6 space-y-4">
                        <Spin spinning={spinning}>
                            <Preview
                                state={state}
                                edit={edit}
                                editObject={editObject}
                                setOpenConfirm={setOpenConfirm}
                                loading={loading}
                                setPublished={setPublished}
                                loadingSaveDraft={loadingSaveDraft}
                                setLoadingSaveDraft={setLoadingSaveDraft}
                                form={form}
                                image={image}
                                values={values}
                                notes={notes}
                                combinedDragData={combinedDragData?.filter(
                                    (c) => c !== undefined
                                )}
                                setCombinedDragData={setCombinedDragData}
                            />
                        </Spin>
                    </div>
                </div>
            </Form>
            <ModalConfirm
                loading={loading}
                title={`${t('Published')} Template ?`}
                text={`<div><div className="bg-purple w-max px-4 m-auto py-1 text-white rounded-lg mb-2"> ${t(
                    'PublishedVersion'
                )}: ${version} </div> <p>${t('ModalDesPublish')}</p> </div>`}
                open={openConfirm}
                handelOk={() => {
                    setLoading(true);
                    form.submit();
                }}
                handelClose={() => setOpenConfirm(false)}
            />
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
        </>
    );
};

export default Steps;
